export default __webpack_public_path__ + "static/media/카카오뱅크.47378748.svg";